import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { validate } from '../lib/clientValidator';
import Divider from './divider/Divider';
import PropTypes from 'prop-types';
import { BTN_FACTORY_FORM } from '../clientConstants';
import { connect } from 'react-redux';
import Collapsible from './collapsible/Collapsible';
import VxRadioField from './vxFields/VxRadioField';
import VxSimpleInputField from './vxFields/VxSimpleInputField';
import ExtraVariablesTextArea from './ExtraVariablesTextArea';
import getLocaleMessages from '../utils/localesMessages';
import { setLocalizationParams } from '../utils/localizationHelpers';
import _map from 'lodash/map';
import _get from 'lodash/get';
import { trackWizardStep } from '../utils/ButtonFactoryFPT';
import $ from 'jquery';

const {
	header,
	options: {
		donorInfo,
		route,
		acctIdentifier,
		extraVariable,
		label
	}
} = getLocaleMessages('buttons/wizardStepFour');

const {
	finish
} = getLocaleMessages('buttons/wizardStepThree');

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state) || {};

	return {
		locale: _get(state, 'application.locale'),
		country: _get(state, 'application.country'),
		email: _get(state, 'application.accountIdentifier.email'),
		initialValues: state.buttonFactory.formattedButton,
		formValues
	}
}

class WizardStep4 extends Component {
	static propTypes = {
		formValues: PropTypes.object,
		initialValues: PropTypes.object,
		handleSubmit: PropTypes.func,
		onSubmit: PropTypes.func,
		buttonFactory: PropTypes.object,
		updateCodeSnippet: PropTypes.func,
		email: PropTypes.string,
		locale: PropTypes.string,
		country: PropTypes.string
	}

	componentDidMount() {
		$('.main-container').animate({ scrollTop: 0 }, 400);

		trackWizardStep({
			step: 4
		});
	}

	getValue = (key) => {
		return this.props.formValues[key];
	}

	renderShippingAddressDisabled = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	renderNoteDisabled = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	renderExtraVariablesAreaField = (props) => {
		return (
			<ExtraVariablesTextArea {...props} />
		)
	}

	renderSimpleTextField = (props) => {
		return (
			<VxSimpleInputField {...props} />
		)
	}

	renderAccountIdentifierType = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	onChange = (props) => {
		const { updateCodeSnippet } = this.props;
		updateCodeSnippet(props);
	}

	renderDonorInfo = () => {
		const noShipping = this.getValue('noShipping');
		const noNote = this.getValue('noNote');

		const donorInfoNote = setLocalizationParams(donorInfo.note, {
			locale: this.props.locale,
			country: this.props.country
		});

		return (
			<div>
				<div className="optional-body">
					<p className="margin-top-1">{donorInfo.mailingAddr}</p>
					<Field
						type="radio"
						id="noShippingNo"
						name="noShipping"
						value="no"
						checkedValue={noShipping}
						component={this.renderShippingAddressDisabled}
						label={label.yes}
					/>
					<div className="note" dangerouslySetInnerHTML={{ __html: donorInfoNote }}></div>
					<Field
						type="radio"
						id="noShippingYes"
						name="noShipping"
						value="yes"
						checkedValue={noShipping}
						component={this.renderShippingAddressDisabled}
						label={label.no}
					/>

					<p className="radio-top-label margin-top-2">{donorInfo.optionalNote}</p>
					<Field
						type="radio"
						id="noNoteNo"
						name="noNote"
						value="no"
						checkedValue={noNote}
						component={this.renderNoteDisabled}
						label={label.yes}
					/>
					<Field
						type="radio"
						id="noNoteYes"
						name="noNote"
						value="yes"
						checkedValue={noNote}
						component={this.renderNoteDisabled}
						label={label.no}
					/>
				</div>
			</div>
		)
	}

	renderRouteBackUrls = () => {
		return (
			<div>
				<div className="optional-body margin-top-3">
					<Field
						id="cancelReturn"
						name="cancelReturn"
						type="text"
						component={this.renderSimpleTextField}
						label={route.cancelUrl}
					/>
					<p className="optional-note">{route.cancelExample}</p>

					<Field
						id="return"
						name="return"
						type="text"
						component={this.renderSimpleTextField}
						label={route.completeUrl}
					/>
					<p className="optional-note">{route.completeExample}</p>
				</div>
			</div>
		)
	}

	renderAccountIdentifier = () => {
		const accountIdentifierType = this.getValue('accountIdentifierType');
		const useEmailLabel = acctIdentifier.defaultAccount.replace('{email}', this.props.email);

		return (
			<div>
				<div className="optional-body">
					<p className="margin-top-1">{acctIdentifier.prompt}</p>
					<Field
						type="radio"
						id="accountIdentifierMerchant"
						name="accountIdentifierType"
						value="merchantAccountId"
						checkedValue={accountIdentifierType}
						component={this.renderAccountIdentifierType}
						label={acctIdentifier.merchantAccount}
					/>
					<Field
						type="radio"
						id="accountIdentifierEmail"
						name="accountIdentifierType"
						value="emailAddress"
						checkedValue={accountIdentifierType}
						component={this.renderAccountIdentifierType}
						label={useEmailLabel}
					/>
				</div>
			</div>
		)
	}

	renderExtraVariables = () => {
		const extraVariablesView = this.getValue('extraVariablesView');
		const unsupportedVariables = this.getValue('unsupportedVariables');

		return (
			<div>
				<div className="optional-body extra-variables-container">
					<div>
						<a
							href="https://developer.paypal.com/docs/classic/paypal-payments-standard/integration-guide/Appx_websitestandard_htmlvariables/#"
							target="_blank"
						>
							{extraVariable.link}
						</a>
						&nbsp;
						<img src="https://www.paypalobjects.com/images/Cause/ic_launch.svg" />
					</div>
					<div className="code-textarea supported">
						<Field
							id="extraVariablesView"
							name="extraVariablesView"
							type="text"
							value={extraVariablesView}
							component={this.renderExtraVariablesAreaField}
							label={'Extra Html Variables'}
						/>
					</div>

					{
						unsupportedVariables && unsupportedVariables.length > 0 &&
						<div className="unsupported-variables-container">
							<p className="vx_text-4">{extraVariable.unsupportedVariables}</p>
							<p className="vx_text-legal">{extraVariable.willBeDeletedWarning}</p>

							<div className="unsupported-fields">
								{
									_map(unsupportedVariables, (variable, index) => {
										return (
											<div key={index}>{`${variable.name}=${variable.value}`}</div>
										)
									})
								}
							</div>
						</div>
					}
				</div>
			</div>
		)
	}


	render() {
		const { handleSubmit } = this.props;

		return (
			<div className="wizard-step-container wizard-step-4-container">
				<div className="wizard-step-title">{header}</div>
				<div className="wizard-body">
					<form className="wizard-form">
						<Collapsible headerText={donorInfo.title} collapsibleId="donorInfo">
							{this.renderDonorInfo()}
						</Collapsible>
						<Divider />

						<Collapsible headerText={route.title} collapsibleId="routes">
							{this.renderRouteBackUrls()}
						</Collapsible>
						<Divider />

						<Collapsible headerText={acctIdentifier.title} collapsibleId="accountIdentifier">
							{this.renderAccountIdentifier()}
						</Collapsible>
						<Divider />

						<Collapsible headerText={extraVariable.title} collapsibleId="advancedVariables">
							{this.renderExtraVariables()}
						</Collapsible>
						<Divider />
					</form>
				</div>
				<div className="wizard-footer-button">
					<button
						className="vx_btn"
						type="submit"
						onClick={handleSubmit(this.props.onSubmit)}
						id="nextStep"
						>
						{finish}
					</button>
				</div>
			</div>
		);
	}
}

let WizardStep4Form = reduxForm({
	form: BTN_FACTORY_FORM,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate,
	onSubmitSuccess: (result, dispatch, props) => {
		console.log('onSubmitSuccess in WizardStep4.reduxForm');
	},
	onSubmit: () => {
		console.log('onSubmit in WizardStep4.reduxForm');
	},
	onSubmitFail: errors => {
		// scroll to the first failed element and focus it
		console.log('onSubmitFail in WizardStep4.reduxForm');
	}
})(WizardStep4);

WizardStep4Form = connect(mapStateToProps)(WizardStep4Form);
export default WizardStep4Form;



// WEBPACK FOOTER //
// ./buttons/components/WizardStep4.js